import { LoadingOutlined } from '@ant-design/icons';
import { css } from '@emotion/react';
import useMyRole from '@hooks/useMyRole';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';

const ReconnectingVideoOverlay = () => {
  const myRole = useMyRole();
  const { t } = useTranslation('common');

  const mainOverlay = css`
    height: 100%;
    width: 100%;
    position: absolute;
    inset: 0;
    z-index: 1;
    backdrop-filter: blur(10px);
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 25px;
  `;

  const overlayContent = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    font-weight: 500;
  `;

  return (
    <div css={mainOverlay}>
      <div css={overlayContent}>
        <span
          css={css`
            max-width: 250px;
            margin-bottom: 10px;
          `}
        >
          {t('The')} {myRole === 'clinician' ? t("patient's") : t("clinician's")} {t('connection was disrupted.')}
        </span>
        <span>{t('Reconnecting')}</span>
        <Space style={{ height: 0, marginTop: 10 }} aria-hidden="true">
          <LoadingOutlined spin style={{ fontSize: 30 }} />
        </Space>
      </div>
    </div>
  );
};

export default ReconnectingVideoOverlay;
